/** RecommendationServer.js */
import {GoogleGenerativeAI} from "@google/generative-ai";

import {doc, setDoc, getDoc} from "firebase/firestore";
import {db} from "../firebase/firebase";

const genAI = new GoogleGenerativeAI(process.env.REACT_APP_GEMINI_API_KEY);

export const getRecommendedTrips = async (creatorTripData, tripTemplates) => {

    console.log(process.env.REACT_APP_GEMINI_API_KEY);
    // Construct a detailed prompt for Gemini using the creator's preferences
    const prompt = `
You are a smart travel assistant.
You are given a user's preferences from a trip they created:
${JSON.stringify(creatorTripData, null, 2)}

And you are given a database of predefined trip templates:
${JSON.stringify(tripTemplates, null, 2)}

Your task is to choose the top 5 trip templates that best match the preferences of the user who created the trip.
Only return the ID or title of each suggested trip and a brief explanation of why it's a match.
Do not return extra text or markdown. Just a clean list of suggestions.

Each suggestion format:
- Trip ID or title
- Reason it fits
`;

    try {
        // Using a valid Gemini model — change here if needed
        const model = genAI.getGenerativeModel({model: 'gemini-2.5-flash'});

        const result = await model.generateContent([prompt]);
        const response = await result.response;
        return response.text().trim()
    } catch (error) {
        console.error('Gemini error:', error);
    }
}

export const saveRecommendationsForTrip = async (tripId, recommendedTripIds) => {
    try {
        const ref = doc(db, "tripRecommendations", tripId);
        await setDoc(ref, {
            recommendedTripIds,
            createdAt: new Date()
        });
    } catch (error) {
        console.error("שגיאה בשמירת ההמלצות:", error);
    }
};

export const loadRecommendationsFromDB = async (tripId) => {
    try {
        const ref = doc(db, "tripRecommendations", tripId);
        const snapshot = await getDoc(ref);
        if (snapshot.exists()) {
            return snapshot.data().recommendedTripIds;
        }
        return null;
    } catch (error) {
        console.error("שגיאה בטעינת המלצות מ־DB:", error);
        return null;
    }
};
